<ion-header class="header">
    <ion-title>
        {{ "reports.selectCycle" | translate }}
    </ion-title>
</ion-header>
<ion-content class="content">
    <ion-grid>
        <ion-row *ngFor="let cycle of cycles">
            <ion-item (click)="selectCycle(cycle.id)" lines="none" class="checkbox">
                <ion-label class="ion-text-wrap">
                    {{ cycle?.name }}
                </ion-label>
                <ion-checkbox custom-checkbox slot="start" mode="ios"
                    [checked]="cycle.id === selectedCycleId"></ion-checkbox>
            </ion-item>
        </ion-row>
    </ion-grid>
</ion-content>
<ion-footer class="footer">
    <ion-button class="btn-select-cycle" mode="ios" color="danger" size="default" (click)="dismiss()">
        {{ 'generic.cancel' | translate }}
    </ion-button>
    <ion-button class="btn-select-cycle" mode="ios" color="primary" size="default" (click)="dismiss(true)">
        {{ 'generic.ok' | translate }}
    </ion-button>
</ion-footer>